<body>
    <div class="title">
        <span class="titleData">Add New Details </span>
        <i class="fa fa-times" aria-hidden="true" style="cursor: pointer;" (click)="close()"></i>
    </div>
    <div class="body">
        <span class="dataContainer">
            <label for="" class="selectionLabel">Name</label>
            <input type="text" class="input" [value]="relationName" #relName (input)="getRelationName(relName.value)">
        </span>
        <span class="dataContainer" style="height: auto;">
            <label for="" class="selectionLabel">Mobile Number</label>
            <input type="text" class="input" maxlength="10" [value]="mobilenumber" style="height: 40px !important;" #relMobile (input)="restrictToNumbers($event)" (input)="getRelationMobileNumber(relMobile.value)">
            <span style="font-size: 14px;color: #DE2424;" *ngIf="showerror">Enter a valid Mobile Number</span>
        </span>
        <span class="dataContainer">
            <label for="" class="selectionLabel">Relation</label>
            <mat-select id="reasons" class="input" placeholder="Select Relation" style="display: flex;"
                [(ngModel)]="selectedRelation">
                <mat-option *ngFor="let item of familyRelations " [value]="item.relation" (click)="Relation(item.relation)">{{item.relation}}</mat-option>
            </mat-select>
        </span>
        <span class="dataContainer"style="height: auto;">
            <label for="" class="selectionLabel">Adharcard Number (Opptional)</label>
            <input type="text" class="input" [value]="relationaadhar" maxlength="12"  style="height: 40px !important;" #reladmNo (input)="restrictToNumbers($event)" (input)="getRelationaadhar(reladmNo.value)">
            <span style="font-size: 14px;color: #DE2424;"  *ngIf="aadharerror">Enter a valid Aadhar Number</span>
        </span>
    </div>
    <div *ngIf="submitOrNot" style="width: 100%;">
        <img [src]="photo" alt="" style="width: 60px;margin-top: 10px;margin-left: 10px;">
    </div>
    <div class="buttons">
        <button class="button" *ngIf="!submitOrNot" (click)="uploadPhoto()">Upload Photo</button>
        <button class="button" *ngIf="submitOrNot" (click)="submitFamilyDetails()">Submit Family Details</button>
    </div>
    <!-- ================================ loader ======================-->
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
</body>